module.exports = __webpack_public_path__ + "img/4.5c010655.jpg";